<ng-container *ngIf='brand'>
  <div fxLayout='column'>
    <div *ngIf='onboardingView' fxLayout='row' fxFlex='80%' fxLayoutAlign='center' class='integration-header'>
      Integrations
    </div>
    <div *ngIf='onboardingView' fxLayout='row' fxLayoutAlign='end' style='margin-bottom: 2%' fxFlex='80%'>
      <button mat-raised-button color='primary' (click)='invite(null)'>
        MANAGE INTEGRATIONS
      </button>
    </div>
  </div>
  <div class='integration-list' fxLayout='row wrap' *ngIf='!manageSelected && invitesInitialized'>
    <mat-card *ngFor='let int of filteredIntegrations' class='integration-card' fxLayout='column'>
      <img mat-card-image [src]='int.img' [alt]='int.name' class='integration-logo' />

      <div
        fxFlex
        fxLayoutAlign='center'
        class='integration-subheader'
        *ngIf="int.type === 'google_ads_read_only' || (!integrationConnected(int) && !integrationHasInvite(int))"
      >
      <span [hidden]='!int.subHeader'>
        {{ int.subHeader }}
      </span>
      </div>

      <div *ngIf='onboardingView' fxLayout='row' fxLayoutAlign='center'>
        <a mat-button target='_blank' class='install-button my-xs' [href]='int.helplink'>
          Install Guide
        </a>
      </div>

      <div class='status-container'>
        <div class='mb-md'
             *ngIf='(integrationHasInvite(int) || integrationConnected(int)) && integrationConnected(int)'>
          <ng-container>
            <div fxLayout='row wrap' fxLayoutAlign='center'>
              <mat-icon fxFlex='29px' style='margin: 5px auto' class='mat-text-green'>thumb_up</mat-icon>
              <span fxFlex='120px' class='mat-text-green' style='align-self: center'
              >{{ int.connectedIntegrations.length > 1 ? int.connectedIntegrations.length + ' ' : '' }}Connected</span
              >
            </div>
          </ng-container>
        </div>

        <div class='mb-md' *ngIf='!integrationConnected(int) && integrationHasInvite(int)'>
          <ng-container>
            <div fxLayout='row wrap' fxLayoutAlign='start center'>
              <mat-icon fxFlex='29px' style='margin: 5px auto'>access_time</mat-icon>
              <span fxFlex='120px' style='align-self: center'>Pending</span>
            </div>
          </ng-container>
        </div>
      </div>

      <!--    Spacer for subheader-->
      <div fxFlex class='integration-subheader' *ngIf='integrationConnected(int) || integrationHasInvite(int)'></div>

      <!--no integrations-->
      <div
        *ngIf='!int.connectedIntegrations.length > 0'
        fxFlex
        fxLayout='column'
        fxLayoutAlign='center'
        class='button-container'
        fxLayoutGap='10%'
      >
        <!--no invite-->
        <span
          fxLayout='column'
          fxLayoutAlign='center'
          fxFlex='100%'
          class='btn-container'
          fxLayoutGap='10%'
          *ngIf='!integrationHasInvite(int)'
        >
        <button
          fxLayout='row'
          fxLayoutAlign='center'
          mat-raised-button
          color='primary'
          (click)='handleClick(int)'
          class='connect-button'
        >
          CONNECT
        </button>
        <button mat-stroked-button class='int-manage-btn' color='primary' (click)='invite(int)'>
          INVITE MANAGER
        </button>
      </span>
        <!--has invite-->
        <span
          fxLayout='column'
          fxLayoutAlign='center'
          fxFlex='100%'
          class='button-container'
          fxLayoutGap='10%'
          *ngIf='integrationHasInvite(int)'
        >
        <button
          fxLayout='row'
          fxLayoutAlign='center'
          mat-raised-button
          color='primary'
          (click)='handleClick(int)'
          class='connect-button'
        >
          CONNECT
        </button>
        <button
          *ngIf='integrationHasInvite(int)'
          mat-stroked-button
          (click)='handleManageClick(int)'
          class='int-manage-btn'
          color='primary'
        >
          MANAGE INVITE
        </button>
      </span>
      </div>

      <!--has integrations-->
      <div
        *ngIf='int.connectedIntegrations.length > 0'
        fxFlex
        fxLayout='column'
        fxLayoutAlign='center'
        class='button-container'
        fxLayoutGap='10%'
        [ngStyle]="subHeaderAndConnected(int) ? {'padding-bottom': '32px'} : {}"
      >
        <!--no invite-->
        <span
          fxLayout='column'
          fxLayoutAlign='center'
          fxFlex='100%'
          class='btn-container'
          fxLayoutGap='10%'
          *ngIf='!integrationHasInvite(int)'
        >
        <button
          fxLayout='row'
          fxLayoutAlign='center'
          mat-raised-button
          color='primary'
          (click)='handleClick(int)'
          class='connect-button'
        >
          CONNECT
        </button>
        <button mat-stroked-button class='int-manage-btn' color='primary' (click)='invite(int)'>
          INVITE MANAGER
        </button>
      </span>
        <!--has invite-->
        <span
          fxLayout='column'
          fxLayoutAlign='center'
          fxFlex='100%'
          class='button-container'
          fxLayoutGap='10%'
          *ngIf='integrationHasInvite(int)'
        >
        <button
          fxLayout='row'
          fxLayoutAlign='center'
          mat-raised-button
          color='primary'
          (click)='handleClick(int)'
          class='connect-button'
        >
          CONNECT
        </button>
        <button
          *ngIf='integrationHasInvite(int)'
          mat-stroked-button
          (click)='handleManageClick(int)'
          class='int-manage-btn'
          color='primary'
        >
          MANAGE INVITE
        </button>
      </span>
      </div>
    </mat-card>
  </div>
  <span *ngIf='isAdmin && manageSelected && advertiser && brand'>
  <app-manage-integrations
    [selectedBrand]='brand'
    [selectedIntegration]='selectedIntegration'
    [advertiser]='advertiser'
    (onBackClick)='onBackClick()'
    [isStandalone]='true'
  ></app-manage-integrations>
</span></ng-container>
